function getRiskScoreValue(value?: number | boolean) {
  if (typeof value === 'undefined') {
    return null;
  }

  return Math.round(+value * 10000) / 100;
}

export default getRiskScoreValue;
